import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import Crumb from "../components/Crumb.vue";
// import MaterialQuestionEdit from "@/views/data-manage/question/material-edit/index.vue";
// import QuestionEdit from "@/views/data-manage/question/edit/index.vue";
import ExamInfo from "../components/ExamInfo.vue";
import ChoosePapers from "../components/ChoosePapers.vue";
import ExamPublish from "../components/ExamPublish.vue";
import { saveExamDetail } from "@/api/exam";
import { checkSession } from "@/api/commom";
import eventEmitter from "@/utils/eventEmitter";
let ExamEdit = class ExamEdit extends Vue {
    constructor() {
        super(...arguments);
        this.examId = '';
        this.editingQuestion = !1;
        this.editingMaterialQuestion = !1;
        this.step = 0;
        this.isLoading = !1;
        this.examInfo = {
            id: '',
            name: '',
            imgUrl: '',
            detail: '',
            paperId: '',
            coursePassScore: -1,
            publishStatus: 0,
            hasUser: false
        };
        this.hasStepOneChange = false;
        this.hasStepTwoChange = false;
        this.aliveInterval = null;
        this.shouldDialogShow = true;
    }
    created() {
        const query = this.$route.query;
        this.examId = query.exam_id;
        if (this.examId) {
            this.examInfo.id = this.examId;
        }
        const step = query.step || '1';
        this.goPage(Number(step));
        this.aliveInterval = setInterval(() => {
            checkSession();
        }, 30 * 1000);
        eventEmitter.on('routerRapture', () => this.shouldDialogShow ? Promise.reject() : Promise.resolve());
    }
    beforeDestroy() {
        clearInterval(this.aliveInterval);
    }
    clickCrumbGoPage(step) {
        if (1 === this.step) {
            if (3 == step)
                return this.$message.warning("请先完成第二步的题目设置");
            this.stepOne.next();
        }
        else if (2 === this.step) {
            if (3 == step) {
                if (!this.examInfo.paperId)
                    return this.$message.warning("请先完成第二步的题目设置");
                // this.stepTwo.next()
            }
            else {
                1 == step && this.goPage(step);
            }
        }
        else {
            3 === this.step && this.goPage(step);
        }
    }
    goPage(step) {
        this.step = step;
    }
    getExamInfo(step) {
        const examinfo = this.examInfo;
        if (step === 1 && this.hasStepOneChange) {
            return {
                name: examinfo.name,
                imgUrl: examinfo.imgUrl,
                detail: examinfo.detail,
            };
        }
        else if (step === 2 && this.hasStepTwoChange) {
            return {
                hasUser: examinfo.hasUser,
                coursePassScore: examinfo.coursePassScore,
                paperId: examinfo.paperId
            };
        }
        return null;
    }
    setCurrentExamInfo(examInfo, step) {
        if (step === 1) {
            this.hasStepOneChange = true;
        }
        else if (step === 2) {
            this.hasStepTwoChange = true;
        }
        this.examInfo = {
            ...this.examInfo,
            ...examInfo
        };
    }
    loading(e) {
        this.isLoading = e;
    }
    async createdExamination(status) {
        this.examInfo.publishStatus = status;
        this.isLoading = true;
        try {
            await saveExamDetail({
                id: this.examId || void 0,
                name: this.examInfo.name,
                imgUrl: this.examInfo.imgUrl,
                detail: this.examInfo.detail,
                paperId: this.examInfo.paperId,
                coursePassScore: this.examInfo.coursePassScore,
                examStatus: status,
            });
            this.$message.success("保存考试成功");
            this.shouldDialogShow = false;
            setTimeout(() => this.goBackToList(), 600);
        }
        catch (_) { }
        finally {
            this.isLoading = false;
        }
    }
    goBackToList() {
        this.$router.push({ name: 'Examination' });
    }
};
tslib_1.__decorate([
    Ref()
], ExamEdit.prototype, "stepOne", void 0);
tslib_1.__decorate([
    Ref()
], ExamEdit.prototype, "stepTwo", void 0);
ExamEdit = tslib_1.__decorate([
    Component({
        name: 'ExamEdit',
        components: {
            Crumb,
            ExamInfo,
            ChoosePapers,
            ExamPublish,
        },
    })
], ExamEdit);
export default ExamEdit;
